import { TFunction } from "i18next";
import { PublishedCard } from "../types";
import { CreateCardTranslate } from "./createCardTransformShared";
import { getCreateTaasCardTemplateFlags } from "./createTaasCardPages";
import { PageData } from "./useTemplatePageHelpers";
import { getTemplatePageValidationMessages } from "./useTemplateValidation";

export function getCreateTaasCardPageValidation(
  pages: PageData[],
  card: PublishedCard,
  t: TFunction
): string[][] {
  const { isGiftCardTemplate } = getCreateTaasCardTemplateFlags(card, t);
  return pages.map((page, index) =>
    getTemplatePageValidationMessages({
      page,
      pageIndex: index,
      isGiftCardTemplate,
      t,
    })
  );
}

export function hasCreateTaasCardValidationErrors(pageValidationMessages: string[][]): boolean {
  return pageValidationMessages.some((messages) => messages.length > 0);
}

export function firstCreateTaasCardValidationMessage(
  pageValidationMessages: string[][]
): string | undefined {
  return pageValidationMessages.flat().find((message) => message.trim());
}
